import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { emailActionCall } from '../../API/api';

export default function EmailAction() {
    const {id} = useParams();
    const [isLoading, setIsLoading] = React.useState(true);
    const [msg, setMsg] = React.useState('Please wait while we process your request...');
    const callApi=() => emailActionCall({userUuid: id}).then(res=>{
        if (res === undefined) {
            return;
        }
        setMsg(res.data.message);
    })

    useEffect(()=>{
callApi();
    },[])
  return (
    <div style={{textAlign: 'center', marginTop: '5%', fontSize: '28px', fontWeight: 'bold',color:'#5c667b'}}>
        <span>{msg}</span>
    </div>
  )
}
